import { Box } from '@mui/material';
import React from 'react';

const CustomFormAction: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box mt={3} display='flex' flexDirection='row' justifyContent='flex-end'>
      {children}
    </Box>
  );
};


export default CustomFormAction;
